<template>
  <!--    <HelloWorld msg="Welcome to Your Vue.js App" />-->

  <div style="width: 100%;">
    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_home_img_banner.jpg"
      style="width: 100vw;height: 42vw;margin-top:2px;"
    />

    <div class="mapview fx-column fx-row-center">
      <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">丰富的广告资源</div>

      <div class="blueline"></div>

      <!-- bigh3label -->
      <div
        :class="ISphone ? smallh2label : bigh2label"
        style="margin-top: 3vw;width:80vw;"
      >优质APP全覆盖，10,000+合作广告主，上亿级累计覆盖设备。愉悦推基于优化算法将流量更好地</div>

      <div
        :class="ISphone ? smallh2label : bigh2label"
        style="width:90vw;"
      >匹配与引导至您所需的推广方向，帮助广告投放更加精准！</div>

      <img
        src="http://pic.midongtech.xyz/yytgw/assets/img_home_img_map.png"
        style="width: 68vw;height: 33vw;margin-top: 4vw;"
      />

      <!-- smallh2label  bigh2label -->
      <div
        @click="jumptocontanctus"
        class="darkbuttoncolor hvr_grow_shadow"
        :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
      >{{ISphone?'联系我们':'我要投放广告'}}</div>
    </div>

    <!--    合作资源 cooperation -->

    <div v-if="ISphone" class="fx-column fx-row-center">
      <img
        src="http://pic.midongtech.xyz/yytgw/assets/img_home_img_cooperate_ph.png"
        style="width: 100vw; margin-top:5vw;"
      />

      <!-- smallh2label  bigh2label -->
      <div class="fx-column fx-row-center" style="width:100vw; background: #f3f4f6;">
        <div
          @click="jumptocontanctus"
          style=" margin-top:5vw; margin-bottom:6vw;"
          class="darkbuttoncolor hvr_grow_shadow"
          :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
        >{{ISphone?'联系我们':'我要投放广告'}}</div>
      </div>
    </div>

    <div v-else class="cooperation fx-column fx-row-center">
      <div style="margin-top: 4vw;" :class="ISphone ? smallh1label : bigh1label">合作资源</div>
      <div class="blueline"></div>

      <div class="fx-row fx-row-center fx-row-space-between" style="width: 50vw; margin-top: 5vw;">
        <img
          src="http://pic.midongtech.xyz/yytgw/assets/img_home_img_cooperate_fir.png"
          style="width: 100%;height: auto;"
        />
      </div>

      <div
        :class="ISphone ? smallh2label : bigh2label"
        style="margin-top: 3vw; width:90vw;"
      >优质移动广告平台800+，提供全方位支持与强大控制力，为开发者全面提升变现效率，实现广告投放的最小</div>
      <div :class="ISphone ? smallh2label : bigh2label">投入、最优效果</div>

      <div class="fx-row fx-row-center fx-row-space-between" style="width: 50vw; margin-top: 5vw;">
        <img
          src="http://pic.midongtech.xyz/yytgw/assets/img_home_img_cooperate_sec.png"
          style="width: 100%;height: auto;"
        />
      </div>

      <div
        style="margin-top: 3vw;width:90vw;"
        :class="ISphone ? smallh2label : bigh2label"
      >与国内外顶级企业合作，赢得众多知名品牌信赖，服务广告主1W+，有丰富的整合营销服务经验，覆盖汽车、金融、快消、数码、旅游等多个行业</div>
      <div
        @click="jumptocontanctus"
        :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
        class="darkbuttoncolor hvr_grow_shadow"
      >联系我们</div>
    </div>

    <!--  选项 choosesection -->
    <img
      v-if="ISphone"
      src="http://pic.midongtech.xyz/yytgw/assets/img_home_img_advan_ph.png"
      style="width: 100vw;"
    />
    <div v-else class="choosesection fx-column fx-row-center">
      <div
        :class="ISphone ? smallh1label : bigh1label"
        style="margin-top: 5vw; color: white;"
      >为什么选择愉悦推</div>

      <div class="blueline"></div>

      <div
        class="fx-row fx-row-center fx-row-space-between"
        style="width:80vw; margin-top: 4vw; margin-bottom: 4vw;"
      >
        <div
          class="onesection fx-column fx-row-center"
          v-for="(item, index) in choosesectionArray"
          v-bind:key="index"
          v-bind:style="ISphone ? { height: 75 + 'vw' } : { height: 31 + 'vw' }"
        >
          <div class="he_border1" style="width: 25vw;height: 14.6vw; background:#fe7253; ">
            <img class="he_border1_img" :src="item.iconurl" />
            <div class="he_border1_caption"></div>
          </div>

          <div
            :class="ISphone ? smallh2label : bigh3label"
            style="margin-top: 3.8vw; text-align:center; width: 18.2vw; color:#16214B; "
          >{{ item.titlestr }}</div>
        </div>
      </div>
    </div>

    <!--   业务  bussiness -->
    <img
      v-if="ISphone"
      src="https://pic.midongtech.xyz/img_home_img_work_ph.jpg"
      style="width: 100vw;"
    />

    <div v-else class="bussiness fx-column fx-row-center">
      <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">我们的业务</div>
      <div class="blueline"></div>

      <div
        class="fx-row fx-row-top fx-row-space-between"
        style="width: 75vw; margin-top: 4vw; margin-bottom: 4vw;"
      >
        <div
          class="fx-column fx-row-center"
          v-for="(item, index) in bussinessdataArray"
          v-bind:key="index"
        >
          <img class="bussiness_icon hvr_grow_shadow" :src="item.iconurl" />
          <div
            :class="ISphone ? smallh2label : 'bigh1labelnobold'"
            class="bussiness_title"
          >{{ item.titlestr }}</div>
          <div :class="ISphone ? smallh2label : bigh3label" class="bussiness_des">{{ item.desstr }}</div>
        </div>
      </div>

      <!--      21vw   24.6vw   -->
    </div>

    <div v-if="ISphone">
      <contactusview />
      <partner></partner>
    </div>

    <div v-else>
      <partner></partner>

      <contactusview />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

// import companybtm from "@/components/companybtm.vue";
import partner from "@/components/partner.vue";
import contactusview from "@/components/contactusview.vue";

export default {
  name: "home",

  components: {
    // companybtm,
    contactusview,
    partner
  },

  //
  mounted() {
    //可用于设置自适应屏幕，根据获得的可视宽度（兼容性）判断是否显示
    let w = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (w < 1000) {
      this.$appdata.ISphone = true;
      this.ISphone = this.$appdata.ISphone;
    }

    //      ISphone: false,
    //   this.ISphone = this.$appdata.ISphone;

    // this.ISphone = this.$appdata.ISphone;
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",

      swiperOption: {
        spaceBetween: 30,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      // testicon:("http://pic.midongtech.xyz/yytgw/assets/img_common_img_business_thir.png"),
      teststr:
        "愉悦推自有优质媒体资源搭配合作移动广" +
        "告平台,提供全方位移动平台投放",
      choosesectionArray: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_home_img_case_fir.png",
          titlestr:
            "愉悦推自有优质媒体资源搭配合作移动广告平台， 提供全方位移动平台投放"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_home_img_case_sec.png",
          // 小程序、ASO、CPM、CPT、CPC、CPA
          titlestr:
            "愉悦推支持小程序、CPM、CPT、CPC、CPA、CPL等广告形式，变现模块有H5资讯站/H5小说站/H5小说赚/App应用试玩/小程序分发/表单类CPA广告分发等，根据推广目标定制投放方案"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_home_img_case_thir.png",
          titlestr:
            "愉悦推自有优质媒体资源搭配合作移动广告平台， 提供全方位移动平台投放"
        }
      ],
      bussinessdataArray: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_business_fir.png",
          titlestr: "信息流广告投放",
          desstr:
            "合作800+优质移动广告平台，愉悦推支持开屏、横幅、信息流、激励视频、应用墙等多种广告投放形式，通过推荐算法为广告主匹配精准优质用户"
        },
        // {
        //   iconurl:
        //     "http://pic.midongtech.xyz/yytgw/assets/img_common_img_business_sec.png",
        //   titlestr: "iOS一站式推广",
        //   desstr:
        //     "愉悦推通过算法帮助广告主将App/小程序投放到优质的平台中以获得精准的用户下载，提升App/小程序日活与留存。以及提供上架/快审、选词筛词、ASO/ASM、数据追踪、评论优化、行业报告在内的ISO移动营销综合服务"
        // },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_business_thir.png",
          titlestr: "电商推广",
          desstr:
            "愉悦推通过多种媒体渠道为商品、店铺、平台导入优质、高留存率用户流量，打造流量IP，实现IP带货变现，利用整合营销提升整合销售额及品牌竞争力"
        }
      ]
    };
  },

  methods: {
    jumptocontanctus() {
      //  跳入联系我们
      //push jump
      this.$router.push({
        path: "/ContactUs"
      });
    }
  }
};
</script>

<style lang="less" scoped>
/*页面公共样式*/

.el-carousel__item h3 {
  color: #475669;
  // 14px
  font-size: 1vw;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.mapview {
  width: 100vw;
}

/*<!--    合作资源 cooperation --> */
.cooperation {
  width: 100vw;
  // height: 50vw;
  background: #f3f4f6;
}
/*  <!--  选项 choosesection --> */
.choosesection {
  width: 100vw;
  // height: 50vw;
  background: #16214b;
}

/*  <!--   合作伙伴 partner  --> */
.partner {
  width: 100vw;
  /*height: 83vw;*/
  background: #16214b;
}

// .onesection {
//   width: 25vw;
//   background: #ffffff;
//   border-radius: 10px;
// }
</style>
